let timeBack = 10;
const handleF = () => {
  const targets = document.querySelectorAll('[href="/cart"]');  
  if (targets.length > 0) {
    targets.forEach(cartEle => {
      cartEle.addEventListener("click", () => {
          const id = setInterval(() => {
              if (document.querySelector(".cart-drawer.is-open")) {
                  window.dispatchEvent(new Event("bss_b2b:CustomInitCartSubject"))
                  clearInterval(id);
              }
          }, 200);
          setTimeout(() => clearInterval(id), 5000);
      })
    })
  }
  else if (timeBack-- > 0) setTimeout(handleF, 300);
}
handleF();
